import * as React from "react";
import { Switch } from "react-router-dom";
import HoldEquityContainer from "../components/toc/holdings/holdContainer/holdEquityContainer";
import HoldMfContainer from "../components/toc/holdings/holdContainer/holdMfContainer";
import PostLogin from "./postLogin";

const HoldingsRouting = () => {
	return (
		<Switch>
			<PostLogin path="/holding/equity/:hold" component={HoldEquityContainer} />
			<PostLogin path="/holding/mf/:hold" component={HoldMfContainer} />
		</Switch>
	);
};
export default HoldingsRouting;
